import Clipboard from 'clipboard'
import { message } from 'ant-design-vue'

const clipboardDirective = {
  bind(el, binding) {
    if (binding.arg === 'success') {
      el._v_clipboard_success = binding.value
    } else if (binding.arg === 'error') {
      el._v_clipboard_error = binding.value
    } else {
      const clipboard = new Clipboard(el, {
        text: () => binding.value,
        action: () => 'copy',
      })
      clipboard.on('success', (e) => {
        const callback = el._v_clipboard_success
        callback && callback(e)
        e.clearSelection()
        message.success('复制成功')
      })
      clipboard.on('error', (e) => {
        const callback = el._v_clipboard_error
        callback && callback(e)
      })
      el._v_clipboard = clipboard
    }
  },
  update(el, binding) {
    if (binding.arg === 'success') {
      el._v_clipboard_success = binding.value
    } else if (binding.arg === 'error') {
      el._v_clipboard_error = binding.value
    }
  },
  unbind(el) {
    if (el._v_clipboard) {
      el._v_clipboard.destroy()
    }
  },
}

export default clipboardDirective
